import React from 'react';
import get from 'lodash/fp/get';
import PropTypes from 'prop-types';
import { Form as RFForm } from 'react-final-form';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { BUTTON_TYPE, WaeButton as Button } from '../../components/Button/Button';
import { buildFormField } from '../../components/Form/formFieldFactory';
import theme from '../../theme/theme';

import { NotificationSettingsData } from './FormData/NotificationSettingsData';
import { sectionHeaderStyling } from './styling';

const NotificationSettingForm = ({ handleOnSubmitNotificationSetting, user }) => (
  <RFForm
    onSubmit={handleOnSubmitNotificationSetting}
    initialValues={{
      notificationSettingsPhoneValue:
        get(['phone', 'phoneNumber'], user) ?? get(['candidate', 'phoneNumber'], user),
    }}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit} id="notificationFormID">
        <Typography
          sx={{
            ...sectionHeaderStyling,
            margin: theme.spacing(4, 0, 4, 0),
          }}
        >
          Notification Settings
        </Typography>
        <Grid container spacing={2.5} direction="column">
          <Grid item>{buildFormField(NotificationSettingsData.phone)}</Grid>
        </Grid>

        <Button
          sx={{ margin: theme.spacing(4, 0, 0, 0), padding: theme.spacing(1, 3, 1, 3) }}
          type={BUTTON_TYPE.SUBMIT}
          text={LanguageConverter('button.settings.notification.update')}
        />
      </form>
    )}
  />
);

NotificationSettingForm.propTypes = {
  handleOnSubmitNotificationSetting: PropTypes.func,
  user: PropTypes.shape({}),
};

export default NotificationSettingForm;
